import { createContext } from 'react';
import IEstate from '../interfaces/IEstate';
const EstateMainContext = createContext<IEstate>({} as IEstate);
export default EstateMainContext;
